import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

const modelUrl = process.env.REACT_APP_MODELPATH+"sofacushion2.glb";

export default function SofaCushion2Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF(modelUrl);
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object536.geometry}
        material={materials["Custom (1)"]}
      />
    </group>
  );
}

useGLTF.preload(modelUrl);